<template>
    <div
    class="tw-relative tw-flex tw-w-full tw-flex-col tw-justify-center tw-gap-5 tw-px-4 tw-py-9 tw-text-start"
    :style="`background-color: var(--c-${vars.backgroundColor}); border-radius: var(--rounded); border: 1px solid var(--c-border);`"
  >
   
    <library-image v-if="vars.photoImage && !vars.videoUrl" :src="vars.photoImage" :w-ratio="3" :h-ratio="2" class="tw-h-auto tw-w-full" />
    <library-iframe v-else-if="vars.videoUrl" :src="vars.videoUrl" />
    
    <h4>{{ vars.titleText }}</h4>
    <p v-if="vars.descriptionText">
      {{ vars.descriptionText }}
    </p>
    <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-4 2xl:tw-flex-row lg:tw-gap-4">
      <nuxt-link
        v-for="(button, index) in buttons"
        :external="true"
        :key="index"
        :class="`n-${button.type} n-btn tw-w-full`"
        :to="button.link"
      >
        {{ button.label }} 
      </nuxt-link>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'InfoCard',

  mixins: [ComponentMixin],



  computed: {
    variant() {
      return useVariant(this.component);
    },

    buttons() {
      return this.groupedVariables.buttons;
    },

    descriptions() {
      return this.groupedVariables.descriptions;
    },
  },
});
</script>
